module.exports = __webpack_public_path__ + "img/35.1c785a8.jpg";